import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

export function CountryDynamicFields({ state, register, getValues }) {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [countryCheck, setCountryCheck] = useState(false);

  useEffect(() => {
    if (state.data[0]?.countryID === 208) {
      setCountryCheck(true);
    }
  }, [state.data]);
  return (
    <>
      <div className="col-md-6 col-lg-4">
        <div controlId="countryID">
          <label className="my-2">{t('Country')}</label>

          <select
            className=" w-full cursor-not-allowed border py-2 border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block"
            as="select"
            disabled="true"
            {...register('countryID')}
            onClick={() => {
              const values = Number(getValues('countryID'));
              if (values === 208) {
                setCountryCheck(true);
              } else {
                setCountryCheck(false);
              }
            }}
          >
            {state?.countries?.map((country) => (
              <option
                key={country?.countryID}
                value={country?.countryID}
                defaultValue={country?.countryID === state?.data[0]?.countryID}
              >
                {isActive ? country?.ar_SA : country?.countryName}
              </option>
            ))}
          </select>
        </div>
      </div>

      {countryCheck && (
        <div className="col-md-6 col-lg-4">
          <div controlId="emiratesID">
            <label className="my-2">{t('Emirates')}</label>
            <select
              className=" w-full border py-2 border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block"
              as="select"
              {...register('emiratesID')}
            >
              {state.emirates.map((emirates) => (
                <option
                  key={emirates.emiratesID}
                  value={emirates.emiratesID}
                  defaultValue={emirates.emiratesID === state.data[0]?.emiratesID}
                >
                  {isActive ? emirates?.ar_SA : emirates.en_US}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
      <div className="col-md-6 col-lg-4">
        <div controlId="workTypeID">
          <label className="my-2">{t('Work Type')}</label>
          <select
            className=" w-full border py-2 border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen   block"
            as="select"
            {...register('workTypeID')}
          >
            {state.getWorkTypeList.map((workType) => (
              <option
                key={workType.workTypeID}
                value={workType.workTypeID}
                defaultValue={workType.workTypeID === state.data[0]?.workTypeID}
              >
                {t(workType.en_Us)}
              </option>
            ))}
          </select>
        </div>
      </div>
    </>
  );
}
